import { SelectedFilters } from '@/components/FilterData/types';
import { SearchType } from '../types';

export const buildSearchContextKey = ({
  assetId,
  searchType,
  selectedFilters,
  searchQuery,
  activeThreshold,
  tenantId,
}: {
  assetId?: string;
  searchType?: SearchType;
  selectedFilters: SelectedFilters;
  searchQuery?: string;
  activeThreshold?: number;
  tenantId?: string;
}) =>
  [
    assetId ?? '',
    searchType ?? '',
    JSON.stringify(selectedFilters),
    searchQuery ?? '',
    activeThreshold ?? '',
    tenantId ?? '',
  ].join('-');
